<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="row w-50">
      <router-link class="btn btn-info m-1" :to="`/dashboard/view-users`"
        >Back</router-link
      >
      <card class="card mt-5 border" title="Create Admin">
        <div v-if="warningMessage" class="alert alert-danger">
          <span class="ti-bell"></span>
          {{ warningMessage }}
        </div>
        <form @submit.prevent="submitForm">
          <div class="row" style="padding: 10px">
            <div class="col-md-6">
              <input
                type="text"
                class="form-control border"
                placeholder="First Name"
                v-model="user.firstName"
                required
              />
            </div>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control border"
                placeholder="Last Name"
                v-model="user.lastName"
                required
              />
            </div>
            <div class="col-md-6">
              <input
                type="email"
                class="form-control border"
                placeholder="Email"
                v-model="user.email"
                required
              />
            </div>
            <div class="col-md-6">
              <input
                type="tel"
                class="form-control border no-dropdown"
                placeholder="Phone Number"
                v-model="user.phoneNumber"
                required
              />
            </div>
            <div class="col-md-6">
              <input
                type="password"
                class="form-control border"
                placeholder="Password"
                v-model="user.password"
                required
              />
            </div>
            <div class="col-md-6">
              <input
                type="password"
                class="form-control border"
                placeholder="Password Confirmation"
                v-model="user.password_confirmation"
                required
              />
            </div>
            <div class="col-md-6">
              <select class="form-control" v-model="user.userType">
                <option value="super-admin">Super Admin</option>
                <option value="role-based">Role Based</option>
              </select>
            </div>
            <div class="col-md-6" v-if="user.userType === 'role-based'">
              <select
                class="form-control border"
                v-model="user.roleId"
                required
              >
                <option value="">Select Role</option>
                <option :value="role._id" v-for="role in roles" :key="role._id">
                  {{ role.role }}
                </option>
              </select>
            </div>
            <div class="col-md-6" v-if="user.userType === 'role-based'">
              <input
                type="text"
                class="form-control border"
                placeholder="Merchant Wallet ID"
                v-model="user.merchantWalletId"
              />
            </div>
          </div>

          <div class="text-center mt-4">
            <button type="submit" class="btn btn-info">
              <div class="spinner-grow" role="status" v-if="loading.show"></div>
              Create Admin
            </button>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      roles: [],
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        userType: "super-admin",
        password_confirmation: "",
        merchantWalletId: "",
        roleId: null,
      },
      warningMessage: "",
    };
  },
  computed: {
    ...mapState(["loading"]),
  },
  methods: {
    ...mapActions(["createUser"]),
    async submitForm() {
      if (this.validateForm()) {
        try {
          const userPayload = { ...this.user };
          if (userPayload.userType === "super-admin") {
            delete userPayload.roleId;
          }
          await this.createUser(userPayload);
          this.warningMessage = "";
          this.$router.push("/dashboard/view-users");
        } catch (err) {
          this.warningMessage = "An error occurred";
        }
      }
    },
    validateForm() {
      if (
        !this.user.firstName ||
        !this.user.lastName ||
        !this.user.email ||
        !this.user.phoneNumber ||
        !this.user.password ||
        !this.user.password_confirmation ||
        (this.user.userType === "role-based" && !this.user.roleId)
      ) {
        this.warningMessage =
          "Please fill out all the required fields before submitting the form.";
        return false;
      }
      if (this.user.password !== this.user.password_confirmation) {
        this.warningMessage = "Passwords do not match.";
        return false;
      }
      return true;
    },
  },
  async mounted() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/role`);
      this.roles = res.data.roles;
    } catch (err) {
      console.error("Error fetching roles:", err);
      this.warningMessage = "Unable to fetch roles.";
    }
  },
};
</script>

<style>
.alert {
  text-align: center;
  color: #f1f1f1 !important;
}
.first-name-field {
  padding-left: 6.5px !important;
}
.no-dropdown::-webkit-inner-spin-button,
.no-dropdown::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
